export default {"src":"/_next/static/media/vivo.ba95b47a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};